/* eslint-disable complexity */
import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { formatCurrency } from '@futrli/localisation';

import { PredictManagementContext } from '../../../predict-management/context/predict-management-context';
import { PerformanceMetricCard } from './performance-metric-card';
import * as styles from './performance-overview.scss';

interface CustomersSuppliersCardsRowProps {
  unpaidCashInFromInvoices?: string;
  unpaidCashOutFromBills?: string;
  daysNumCustomersPaying?: number;
  daysNumPayingToSuppliers?: number;
  isLoading?: boolean;
}

export const CustomersSuppliersCardsRow = ({
  unpaidCashInFromInvoices,
  unpaidCashOutFromBills,
  daysNumCustomersPaying,
  daysNumPayingToSuppliers,
  isLoading = false
}: CustomersSuppliersCardsRowProps) => {
  const { currency } = useContext(PredictManagementContext);
  const intl = useIntl();

  const emptyValue = '-';
  const hasData = unpaidCashInFromInvoices !== undefined && unpaidCashOutFromBills !== undefined;

  const balance = hasData ? Number(unpaidCashInFromInvoices) - Number(unpaidCashOutFromBills) : undefined;
  const balanceFormatted = balance !== undefined
    ? `${balance > 0 ? '+' : ''}${formatCurrency(balance, intl, currency || '', 0, 0)}`
    : emptyValue;

  return (
    <div className={styles.cardsRow} style={{ marginBottom: 0 }}>
      <PerformanceMetricCard
        label={intl.formatMessage({
          id: 'predict.performance_overview.cash_if_invoices_bills_paid',
          defaultMessage: 'Cash if invoices and bills paid'
        })}
        value={balanceFormatted}
        valueColor={balance !== undefined ? (balance >= 0 ? '#007E45' : '#CB374A') : undefined}
        isLoading={isLoading}
      />
      <PerformanceMetricCard
        label={intl.formatMessage({
          id: 'predict.performance_overview.due_invoices_total',
          defaultMessage: 'Due invoices total'
        })}
        value={unpaidCashInFromInvoices !== undefined ? formatCurrency(Number(unpaidCashInFromInvoices), intl, currency || '', 0, 0) : emptyValue}
        isLoading={isLoading}
      />
      <PerformanceMetricCard
        label={intl.formatMessage({
          id: 'predict.performance_overview.due_bills_total',
          defaultMessage: 'Due bills total'
        })}
        value={unpaidCashOutFromBills !== undefined ? formatCurrency(Number(unpaidCashOutFromBills), intl, currency || '', 0, 0) : emptyValue}
        isLoading={isLoading}
      />
      <PerformanceMetricCard
        label={intl.formatMessage({
          id: 'predict.performance_overview.avg_customer_payment',
          defaultMessage: 'Avg. customer payment'
        })}
        value={daysNumCustomersPaying !== undefined ? intl.formatMessage(
          { id: 'predict.performance_overview.days_value', defaultMessage: '{days} days' },
          { days: daysNumCustomersPaying }
        ) : emptyValue}
        isLoading={isLoading}
      />
      <PerformanceMetricCard
        label={intl.formatMessage({
          id: 'predict.performance_overview.avg_payment_to_suppliers',
          defaultMessage: 'Avg. payment to suppliers'
        })}
        value={daysNumPayingToSuppliers !== undefined ? intl.formatMessage(
          { id: 'predict.performance_overview.days_value', defaultMessage: '{days} days' },
          { days: daysNumPayingToSuppliers }
        ) : emptyValue}
        isLoading={isLoading}
      />
    </div>
  );
};
